module.exports = __webpack_public_path__ + "img/wallet_02_biometric_1.9f13f474.png";